import { useContext, useCallback } from 'react';
import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Divider } from 'ui-components/components/divider';
import { Input, version2 } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.css';
import { HelpArticleLink } from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';
import { ProductDetailsContext } from '../../../context';

export const ShipStationFulfillmentSettings = () => {
  const { fulfillmentBarcode, setFulfillmentBarcode, userHasPermission } = useContext(ProductDetailsContext);

  const onInputChange = useCallback(
    (e) => {
      setFulfillmentBarcode(e.target.value);
    },
    [setFulfillmentBarcode],
  );

  return (
    <div className={style['fulfillment-barcodes']}>
      <Divider className={style.divider} orientation='horizontal' />
      <Text textType={TextType.H4} value={messages.fulfillmentBarcodesHeader} />
      <BannerMessageV2
        buttons={
          <HelpArticleLink articleId={linkIDs.InsightsPages}>
            <Text textType={TextType.Caption} value={messages.learnMore} />
          </HelpArticleLink>
        }
        className={style['fulfillment-barcode-banner']}
        content={<Text textType={TextType.Caption} value={messages.fulfillmentBarcodesInfoMessage} />}
        layout={BannerLayout.Inline}
        status={BannerStatus.Info}
      />
      <Text
        className={style['fulfillment-barcode-description']}
        textType={TextType.Paragraph}
        value={messages.fulfillmentBarcodeDescription}
      />
      <Text textType={TextType.Label} value={messages.fulfillmentBarcode} />
      <Input
        className={style['fulfillment-barcode-input']}
        data-testid='fulfillment-barcode'
        disabled={!userHasPermission}
        onChange={onInputChange}
        value={fulfillmentBarcode}
        version={version2}
      />
      <BannerMessageV2
        className={style['fulfillment-barcode-banner']}
        content={<Text textType={TextType.Caption} value={messages.fulfillmentBarcodesWarningMessage} />}
        layout={BannerLayout.Inline}
        status={BannerStatus.Warning}
      />
    </div>
  );
};
